/* 趙雲傳・第 4 章：箕谷（建興六年，228）
 * 一條南北向的山谷：北口是箕谷（趙雲、鄧芝的疑軍據守處，曹真從北邊來），往南是沿著崖壁的閣道，最南是赤崖（赤岸）。 */
export const HOLD = [3000, 1300], NORTH = [3000, 300], GE = [3000, 4250], CHIYA = [3000, 5850], CARTS = [3000, 1850];
export const ROUTE = [[3000, 1850], [3150, 2400], [2850, 3300], [3000, 4250], [3100, 5000], CHIYA];
export const KU = [3350, 6050], SHANG = [2650, 6050]; // 赤岸府庫、將士營（選擇餘絹怎麼處置）
export default {
  id: 'zhaoyun_jigu', name: '箕谷', W: 6000, H: 6500, seed: 2286,
  bases: [CHIYA, [3000, 500]],
  roads: [{ pts: [[3000, 250], NORTH, HOLD, ...ROUTE, [3000, 6400]], w: 200 }],
  rocks: [[2450, 4250, 330, 520], [3550, 4250, 330, 520]],
  woods: 0.95,
  sight: 0.8,
  clearings: [[HOLD[0], HOLD[1], 650], [CHIYA[0], CHIYA[1] + 100, 650], [NORTH[0], NORTH[1] + 100, 300]],
  tents: [{ x: HOLD[0], y: HOLD[1], n: 4, r: 300, chief: true, col: '#3e7b50', flag: '趙' }, { x: CHIYA[0], y: CHIYA[1] + 100, n: 4, r: 320, col: '#3e7b50', flag: '漢' }],
};
